import React from 'react';
import { Grid, FormControlLabel, Checkbox, TextField } from '@mui/material';

const FastAndCovidSection = ({ formData, handleChange, errors }) => {
  return (
    <Grid container spacing={2} sx={{ mt: 1 }}>
      <Grid item xs={12} sm={6}>
        <FormControlLabel
          control={<Checkbox name="fasting_confirmation" checked={formData.fasting_confirmation} onChange={handleChange} color="primary" />}
          label="Fasting Confirmation"
        />
        {formData.fasting_confirmation && (
          <TextField
            label="Last Fasting Time"
            name="fasting_last_time"
            type="datetime-local"
            value={formData.fasting_last_time}
            onChange={handleChange}
            fullWidth
            sx={{ mt: 1 }}
            InputLabelProps={{ shrink: true }}
            inputProps={{
              max: new Date().toISOString().slice(0, 16)
            }}
          />
        )}
      </Grid>
      <Grid item xs={12} sm={6}>
        <FormControlLabel
          control={<Checkbox name="covid_screening" checked={formData.covid_screening} onChange={handleChange} color="primary" />}
          label="COVID-19 Screening"
        />
        {formData.covid_screening && (
          <TextField
            label="COVID screening Date/Time"
            name="covid_screening_date"
            type="datetime-local"
            value={formData.covid_screening_date}
            onChange={handleChange}
            fullWidth
            sx={{ mt: 1 }}
            error={!!errors.covid_screening_date}
            helperText={errors.covid_screening_date}
            InputLabelProps={{ shrink: true }}
            inputProps={{
              max: new Date().toISOString().slice(0, 16)
            }}
          />
        )}
      </Grid>
    </Grid>
  );
};

export default FastAndCovidSection;
